import { ajax } from '../../../services/helper'
class ApiService {

    getEquipmentsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/equipments/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getEquipmentById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/equipments/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getEquipmentGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getPlatformsComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
    


    addEquipment = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/equipments/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editEquipment = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/equipments/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Equipments/services/apiservices.js